/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */

import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'bazis-grid',
    template: '<slot></slot>',
    styleUrls: ['grid.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class GridElement {
    @Input() fixed: boolean = false;

    @HostBinding('class.bazis-grid-fixed') get getGridFixed() {
        return this.fixed;
    }

    constructor() {}
}
